import React from 'react';
import { theme } from '../../config/theme';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

const styles = {
    banner: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 3100,
        padding: 'calc(env(safe-area-inset-top) + 0.5rem) 1rem 0.5rem',
        backgroundColor: '#B45309',
        color: '#FFFFFF',
        fontFamily: theme.typography.fontFamily,
        fontSize: '0.85rem',
        fontWeight: 500,
        textAlign: 'center',
        boxShadow: theme.shadows.soft,
    },
};

/**
 * Aviso fijo mientras el dispositivo no tiene internet: en el celular es común
 * perder la señal y que una carga parezca guardada cuando todavía no llegó al
 * servidor (Firestore la retiene en memoria y se pierde si se cierra la app).
 */
const OfflineBanner = () => {
    const isOnline = useOnlineStatus();
    if (isOnline) return null;

    return (
        <div style={styles.banner} role="status" aria-live="polite">
            Sin conexión a internet. Esperá a que vuelva la señal antes de cargar o modificar operaciones.
        </div>
    );
};

export default OfflineBanner;
